import {defineAction} from 'redux-define';
import {createAction, handleActions} from 'redux-actions';
import {call, put, takeEvery, select} from 'redux-saga/effects';
import Covert from 'covert';
import config from 'config';
import get from 'lodash/get';
import {EVENTS, selectToken} from './utils';

const api = config.cove.api;
const CoveApi = Covert({api});

const namespace = 'api/deals';

// Actions
const GET_DEAL = defineAction('GET_DEAL', EVENTS, namespace);
export const getDeal = createAction(GET_DEAL.ACTION);
export const getDealRequested = createAction(GET_DEAL.REQUESTED);
export const getDealSuccess = createAction(GET_DEAL.SUCCESS);
export const getDealError = createAction(GET_DEAL.ERROR);

const GET_DEAL_INVITES = defineAction('GET_DEAL_INVITES', EVENTS, namespace);
export const getDealInvites = createAction(GET_DEAL_INVITES.ACTION);
export const getDealInvitesRequested = createAction(GET_DEAL_INVITES.REQUESTED);
export const getDealInvitesSuccess = createAction(GET_DEAL_INVITES.SUCCESS);
export const getDealInvitesError = createAction(GET_DEAL_INVITES.ERROR);

// Reducer
const initialState = {};
export const reducer = handleActions({
  [GET_DEAL.REQUESTED]: (state, action) => ({
    ...state,
    [action.payload.id]: {
      ...state[action.payload.id],
      loaded: false,
    },
  }),
  [GET_DEAL.SUCCESS]: (state, action) => ({
    ...state,
    [action.payload.id]: {
      ...state[action.payload.id],
      loaded: true,
      data: action.payload.data,
    },
  }),
  [GET_DEAL_INVITES.REQUESTED]: (state, action) => ({
    ...state,
    [action.payload.id]: {
      ...state[action.payload.id],
      invites: {
        ...(get(state, `${action.payload.id}.invites`)),
        loaded: false,
      },
    },
  }),
  [GET_DEAL_INVITES.SUCCESS]: (state, action) => ({
    ...state,
    [action.payload.id]: {
      ...state[action.payload.id],
      invites: {
        ...(get(state, `${action.payload.id}.invites`)),
        loaded: true,
        data: action.payload.data,
      },
    },
  }),
  // TODO: Handle error
}, initialState);

// Selector
export const selectDeal = (store, id) => get(store, `data.deals.${id}`);
export const selectDealInvites = (store, id) => get(selectDeal(store, id), 'invites');

// API Calls
export const fetchDealApi = (id, token) => CoveApi.deals.get(id, {token});
export const fetchDealInvitesApi = (id, token) => CoveApi.deals.invites(id, {token});
const getDealUnsignedApi = (id, token) => CoveApi.deals.unsigned(id, {token});

// Get Deal Saga
export function* getDealSaga({payload}) {
  const id = payload.id;
  yield put(getDealRequested({id}));

  try {
    const token = yield select(selectToken);
    const data = yield call(fetchDealApi, id, token);
    yield put(getDealSuccess({id, data}));
    return data;
  } catch (error) {
    yield put(getDealError({id, error}));
  }
}

// Get Deal Invites Saga
export function* getDealInvitesSaga({payload}) {
  const id = payload.id;
  yield put(getDealInvitesRequested({id}));

  try {
    const token = yield select(selectToken);
    const {data} = yield call(fetchDealInvitesApi, id, token);
    yield put(getDealInvitesSuccess({id, data}));
  } catch (error) {
    yield put(getDealInvitesError({id, error}));
  }
}

// Get Deal Unsgined agreement URL Saga
export function* getDealUnsignedURLSaga({payload}) {
  const {id} = payload;
  const token = yield select(selectToken);
  try {
    const {url} = yield call(getDealUnsignedApi, id, token);
    return url;
  } catch (error) {
    throw error;
  }
}

export function* sagas() {
  yield takeEvery(GET_DEAL.ACTION, getDealSaga);
  yield takeEvery(GET_DEAL_INVITES.ACTION, getDealInvitesSaga);
}



// WEBPACK FOOTER //
// ./mobile/shared/api/deals.js